import React from 'react'
export const gemini = {
  path: (
    <g key="ePFQMbuEF">
      <path
        d="M15.0706 2C11.5529 2 8.56471 4.70588 8.18824 8.18824C4.70588 8.56471 2 11.5529 2 15.0706C2 18.8941 5.10588 22 8.92941 22C12.4471 22 15.4471 19.2941 15.8118 15.8118C19.2941 15.4353 22 12.4471 22 8.92941C22 5.10588 18.8941 2 15.0706 2ZM20.3765 9.70588C20.2033 10.8421 19.6715 11.8932 18.8588 12.7059C18.0461 13.5186 16.995 14.0503 15.8588 14.2235V9.70588H20.3765ZM3.62353 14.2941C3.79443 13.1558 4.32515 12.102 5.13803 11.287C5.95092 10.472 7.00329 9.93856 8.14118 9.76471V14.2824H3.62353V14.2941ZM14.2353 15.8588C14.0475 17.1315 13.4081 18.2941 12.4339 19.1344C11.4598 19.9746 10.2159 20.4364 8.92941 20.4353C6.25882 20.4353 4.01176 18.4824 3.62353 15.8588H14.2353ZM14.2941 9.70588V14.2824H9.70588V9.70588H14.2941ZM20.3765 8.14118H9.76471C9.95252 6.8685 10.5919 5.70586 11.5661 4.86562C12.5402 4.02538 13.7841 3.56363 15.0706 3.56471C17.7412 3.56471 19.9882 5.51765 20.3765 8.14118Z"
        fill="currentColor"
      />
    </g>
  ),
  viewBox: '0 0 24 24',
}
